module.exports = __webpack_public_path__ + "static/media/lcevc_toggle.03e22665.png";